/**
 * Banner della supervisione (Andrea 2026-10-06): l'admin dell'app e' dentro
 * una lega di cui non e' membro per sistemarla. Sempre visibile in cima, con
 * il tasto per tornare alla propria lega (e al monitor).
 */

import { useAuth } from "../../hooks/useAuth";
import { useEntraInSupervisione } from "../../hooks/useMonitorLeghe";
import { tr } from "../../i18n";

export function BannerSupervisione() {
  const { user } = useAuth();
  const entra = useEntraInSupervisione();
  if (!user?.in_supervisione) return null;
  return (
    <div className="sticky top-0 z-40 bg-warning text-ink">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-2 text-xs font-bold">
        <span aria-hidden>🛠</span>
        <span className="flex-1 min-w-0 truncate">
          In supervisione: «{user.lega_corrente?.nome ?? "lega"}»
          <span className="hidden sm:inline font-normal">
            {" "}
            {tr("· sei dentro come admin dell'app")}
          </span>
        </span>
        <button
          type="button"
          className="shrink-0 px-2.5 py-1 rounded-full bg-primary-deep text-warning hover:opacity-90"
          onClick={() => entra(null, "/admin/leghe-monitor")}
        >
          {tr("Esci")}
        </button>
      </div>
    </div>
  );
}
